export default "__VITE_ASSET__JUsdrIBJ__";